import { render, staticRenderFns } from "./dob.vue?vue&type=template&id=72e87824&lang=pug&"
import script from "./dob.vue?vue&type=script&lang=js&"
export * from "./dob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports